






























































import {Component, Vue} from 'vue-property-decorator';
import {State, namespace} from 'vuex-class';
import CompSelectBox from '@/components/common/CompSelectBox.vue';
import PeriodDateCalendar from '@/components/common/datepicker/PeriodDateCalendar.vue';
import ItemTable from '@/components/common/ItemTable.vue';
import {getToday, addMonth, changeDateFormat} from '@/utils/dateUtils';
import {i18nInObjectList} from '@/utils/i18n';
import {Mall} from 'supporter';

const mallModule = namespace('mall');
@Component({
  components: {CompSelectBox, PeriodDateCalendar, ItemTable}
})
export default class MemberFreeze extends Vue {
  // 쇼핑몰 선택
  @mallModule.Action('fetchMalls') fetchMalls!: () => Promise<any>;
  @State('malls', {namespace: 'mall'})
  private malls!: Mall[];
  private mallNo: number = 0;
  private get mallList() {
    let res: any = [];
    if (this.malls) {
      this.malls.forEach(mall => {
        res.push({
          value: mall.mallNo.toString(),
          name: mall.mallName
        });
      });
    }
    return res;
  }

  // 검색어
  private searchType = 'ALL';
  private searchTypes = [
    {value: 'ALL', name: 'COMMON_ALL'},
    {value: 'USER_ID', name: 'MEMBER_SEARCH_KEY_WORD_USER_ID'},
    {value: 'NAME', name: 'MEMBER_SEARCH_KEY_WORD_NAME'},
    // {value: 'NICKNAME', name: 'MEMBER_SEARCH_KEY_WORD_NICKNAME'},
    // {value: 'EMAIL', name: 'MEMBER_SEARCH_KEY_WORD_EMAIL'},
    // {value: 'MOBILE', name: 'MEMBER_SEARCH_KEY_WORD_MOBILE'}
  ];
  private keyword = '';

  // 휴면전환일자
  private searchDateUsed = 'false';
  private usedTypes = [
    {value: 'false', name: 'MEMBER_SEARCH_DATE_ALL'},
    {value: 'true', name: 'MEMBER_SEARCH_DATE_PEROID'}
  ];
  private startYmd: string = addMonth(new Date(), -3);
  private endYmd: string = getToday();

  // 조회
  private size = 30;
  private freezeData = [] as any;
  private totalCount: number = 0;
  private async search(page: number = 1, size?: number) {
    if (size) {
      this.size = size;
    }
    if (this.searchType !== 'ALL' && this.keyword === '') {
      alert(this.$t('COMMON_PLEASE_INPUT'));
      (this.$refs.keyword as any).focus();
      return;
    }
    let request: any = {
      params: {
        mallNo: this.mallNo,
        searchType: this.searchType,
        keyword: this.keyword,
        searchDateUsed: this.searchDateUsed,
        page,
        pageSize: this.size
      }
    };
    if (this.searchDateUsed === 'true') {
      request.params.startDateTime = this.startYmd + ' 00:00:00';
      request.params.endDateTime = this.endYmd + ' 23:59:59';
    }
    const {data} = await this.$api.getDormantMembers(request);
    this.freezeData = data.contents;
    this.totalCount = data.totalCount;
    this.gridProps.options.pageOptions.page = page;
    this.gridProps.options.pageOptions.perPage = this.size;
    this.gridProps.options.pageOptions.totalCount = data.totalCount;
  }

  // 초기화
  private reset() {
    this.mallNo = this.malls[0].mallNo;
    this.searchType = 'ALL';
    this.keyword = '';
    this.searchDateUsed = 'false';
    (this.$refs.periodDate as any).clickPeriod('3m');
  }

  // 조회결과
  private contentBottomOption = {
    gridName: 'MEMBER_FREEZE_GRID',
    haveConfigBtn: true,
    haveExcelDownBtn: false,
    onLoadSearch: false
  };
  private gridProps = {
    columns: [
      {
        header: 'MEMBER_LIST_ITEM_MEMBER_NO',
        name: 'memberNo',
        align: 'center',
        minWidth: 80
      },
      {
        header: 'MEMBER_LIST_ITEM_MEMBER_NAME',
        name: 'memberName',
        align: 'center',
        minWidth: 100
      },
      {
        header: 'MEMBER_LIST_ITEM_MEMBER_ID',
        name: 'memberId',
        align: 'center',
        minWidth: 140
      },
      // {
      //   header: 'MEMBER_LIST_ITEM_MEMBER_NICKNAME',
      //   name: 'nickname',
      //   align: 'center',
      //   minWidth: 100,
      //   formatter: (cell: any) => {
      //     return cell.row.nickName;
      //   }
      // },
      {
        header: 'MEMBER_LIST_ITEM_MEMBER_GRADE',
        name: 'memberGradeName',
        align: 'center',
        minWidth: 100
      },
      // {
      //   header: 'MEMBER_FREEZE_LIST_ITEM_MEMBER_MOBILE',
      //   name: 'mobileNo',
      //   minWidth: 100
      // },
      // {
      //   header: 'MEMBER_FREEZE_LIST_ITEM_MEMBER_MAIL',
      //   name: 'email',
      //   align: 'center',
      //   minWidth: 140
      // },
      {
        header: 'MEMBER_FREEZE_LIST_ITEM_MEMBER_REGISTER_DATE',
        name: 'joinedDateTime',
        align: 'center',
        minWidth: 100,
        formatter: (cell: any) => {
          return cell.value && changeDateFormat(cell.value, 'YYYY-MM-DD');
        },
        copyOptions: {
          useFormattedValue: true
        }
      },
      {
        header: 'MEMBER_FREEZE_LIST_ITEM_MEMBER_LAST_LOGIN_DATE',
        name: 'lastLoginDateTime',
        align: 'center',
        minWidth: 100,
        formatter: (cell: any) => {
          return cell.value && changeDateFormat(cell.value, 'YYYY-MM-DD');
        },
        copyOptions: {
          useFormattedValue: true
        }
      },
      {
        header: 'MEMBER_FREEZE_LIST_ITEM_MEMBER_PUSH_ON',
        name: 'appPushAgreed',
        align: 'center',
        minWidth: 80,
        formatter: function(cell: any) {
          return cell.value ? 'Y' : 'N';
        },
        copyOptions: {
          useFormattedValue: true
        }
      },
      {
        header: 'MEMBER_FREEZE_LIST_ITEM_MEMBER_SMS_ON',
        name: 'smsAgreed',
        align: 'center',
        minWidth: 80,
        formatter: function(cell: any) {
          return cell.value ? 'Y' : 'N';
        },
        copyOptions: {
          useFormattedValue: true
        }
      },
      {
        header: 'MEMBER_FREEZE_LIST_ITEM_MEMBER_DM_ON',
        name: 'directMailAgreed',
        align: 'center',
        minWidth: 80,
        formatter: function(cell: any) {
          return cell.value ? 'Y' : 'N';
        },
        copyOptions: {
          useFormattedValue: true
        }
      }
    ],
    options: {
      rowHeaders: ['rowNum'],
      header: {
        height: 33
      },
      columnOptions: {
        minWidth: 50,
        resizable: true
      },
      minRowHeight: 31,
      rowHeight: 31,
      bodyHeight: 190,
      pageOptions: {
        perPage: 30,
        page: 1,
        totalCount: 0,
        visiblePages: 5
      }
    }
  };

  private async mounted() {
    await this.fetchMalls();
    this.mallNo = this.malls[0].mallNo;
    await this.search(1);
  }
  private created() {
    this.gridProps = i18nInObjectList(this, this.gridProps, 'columns', 'header');
  }
}
